import { Injectable } from '@angular/core';
import { StorageService } from '../../../services/storage.service';
import { NotificationService } from '../../../services/notification.service';
import { StorageName } from '../../../enum/common-enum';
import { MetalType, ModalPopupSize } from '../../../models/common.model';
import { CommonAgGridDropdownComponent } from './common-ag-grid-dropdown.component';

@Injectable({
  providedIn: 'root'
})
export class CommonAgGridDropdownService {
  isPopupOpen = false;

  constructor(
    private storageService: StorageService,
    private notificationService: NotificationService
  ) {}

  async openDropdownPopup({ rowNode, colId, currentselectedId, tabId , gridApi }) {
    if (this.isPopupOpen || !rowNode) return;

    this.isPopupOpen = true;
    setTimeout(() => document?.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true })), 100);

    let gridData = [];
    switch (colId) {
      case 'productDetailId':
        case 'productId':
        gridData = this.storageService.retrieve(StorageName.PRODUCT_DROPDOWN)?.filter(x => x.extra1 == tabId) || [];
        break;
      case 'categoryId':
        const filterCategoryDropdown = (this.storageService.retrieve(StorageName.CATEGORY_DROPDOWN) || []).filter(x => x?.extra1 === (this.storageService.retrieve(StorageName.LAYOUT_DETAILS)?.branchId?.toString() || '') || x.id == 0);
        gridData = filterCategoryDropdown;
          break;
      case 'caratId':
        gridData = this.storageService.retrieve(StorageName.CARAT_DROPDOWN)?.filter(x => x.extra1 == tabId || x.id == 0) || [];
        break;
      case 'goldCaratId':
        gridData = this.storageService.retrieve(StorageName.CARAT_DROPDOWN)?.filter(x => x.extra1 == MetalType.Gold || x.id == 0) || [];
        break;
      case 'expensesCategoryId':
        gridData = this.storageService.retrieve(StorageName.EXPENSES_LEDGER_CATEGORY_DROPDOWN) || [];
        break;
      case 'accountLedgerId':
        gridData = this.storageService.retrieve(StorageName.ACCOUNTLEDGER_DROPDOWN) || [];
        break;
      case 'nationalityId':
        gridData = this.storageService.retrieve(StorageName.COUNTRY_DROPDOWN) || [];
        break;
    }

    const ID = await this.notificationService.openModalPopup(
      CommonAgGridDropdownComponent,
      { currentselectedId, tabId, gridData, focusedColumnId: colId },
      '',
      ModalPopupSize.MD,
      '',
      false,
      true
    );

    if (rowNode?.data) {
      const value = !(ID) ? '0' : String(ID);
      rowNode.setDataValue(colId, (rowNode.data[colId] = value));
      rowNode?.gridApi?.refreshCells({ rowNodes: [rowNode], force: true });
      gridApi?.setFocusedCell(rowNode.rowIndex, colId);
    }

    this.isPopupOpen = false;
  }
}